document.querySelectorAll('.clients').forEach((clientsElement) => {
    function updateHeaderRibbonAnimation() {
        var clientsGroup = clientsElement.querySelector('.clients__group');
        var logosElement = clientsElement.querySelector('.clients__logos');

        if (clientsGroup) {
            var itemsCount = clientsGroup.children.length;
            var baseTime = 25; // Czas trwania animacji dla 5 elementów
            var animationDuration = (itemsCount / 5) * baseTime;

            var width = clientsGroup.offsetWidth + 'px';
            var widthX2 = clientsGroup.offsetWidth * 2 + 'px';
            
            var styleElement = clientsElement.querySelector('style');

            if (!styleElement) {
                styleElement = document.createElement('style');
                clientsElement.appendChild(styleElement);
            }

            styleElement.textContent = `
                @keyframes clientsStripe {
                    0% {
                        transform: translateX(-${width});
                    }
                    100% {
                        transform: translateX(-${widthX2});
                    }
                }
                .clients__stripe {
                    animation: clientsStripe ${animationDuration}s linear infinite;
                }
            `;

            // Dodaj klasę do elementu .clients__logos
            if (logosElement) {
                logosElement.classList.add('clients__logos--ready');
            }
        } else {
            console.warn('Element with class "clients__group" not found.');
        }
    }

    window.addEventListener('load', updateHeaderRibbonAnimation);
    window.addEventListener('resize', updateHeaderRibbonAnimation);
});